<div class="ms-modal">
    <div class="ms-modal__header">
      <div class="ms-modal__header-text">
        <h3>
          <img src="assets/imgs/magic-search/ms-waveform-icon.svg" width="16" height="16" alt="" style="vertical-align:middle;margin-right:6px;">
          {{activeTab === 'record' ?'Hum to record your vocal':'Upload audio file'}}
        </h3>
        <p>We'll match the melody, timbre &amp; cadence</p>
      </div>
      <button class="ms-modal__close" (click)="cancel()">✕</button>
    </div>

    <!-- Tabs -->
    <div class="ms-modal__tabs">
      <button [class.active]="activeTab === 'record'" (click)="setTab('record')"> <img src="assets/imgs/magic-search/mic.svg" alt="mic"> Record</button>
      <button [class.active]="activeTab === 'upload'" (click)="setTab('upload')"><span class="pi pi-upload" ></span> Upload</button>
      <!-- <button [class.active]="activeTab === 'url'" (click)="setTab('url')"><span class="pi pi-link" ></span> URL</button> -->
    </div>

    <!-- Record -->
    <div *ngIf="activeTab === 'record'" class="ms-modal__body">
      <div class="ms-wave" [attr.data-state]="vizState">
        <div class="ms-wave__strip">
          <span
            *ngFor="let lvl of levels; trackBy: trackByIndex"
            class="ms-wave__bar"
            [style.height.%]="(lvl * 100)">
          </span>
        </div>
      </div>
      <p class="ms-modal__timer">{{ fmt(seconds) }}</p>
      <div class="ms-modal__rec-actions">
        <button *ngIf="!recording" class="ms-btn ms-btn--primary" (click)="startRecording()">
          {{ recorded ? ' &#x21BB; Re-record' : 'Start Recording' }}
        </button>
        <button *ngIf="recording" class="ms-btn ms-btn--danger" (click)="stopRecording()">
          <img src="assets/imgs/magic-search/ms-stop-icon.svg" width="13" height="13" alt="">
          Stop
        </button>
      </div>
      <p *ngIf="recorded" class="ms-modal__success">✓ Clip captured - ready to match</p>
    </div>

    <!-- Upload -->
    <div *ngIf="activeTab === 'upload'" class="ms-modal__body">
      <input #fileInput type="file" accept="audio/*" class="ms-hidden" (change)="onFileSelect($event)" />
      <div class="ms-dropzone" (click)="triggerFileInput()">
        <ng-container *ngIf="!fileName">
          <div class="ms-dropzone__icon">
            <img src="assets/imgs/magic-search/ms-upload-cloud.svg" width="28" height="24" alt="">
          </div>
          <p class="ms-dropzone__label">Drop an audio file or click to browse</p>
          <p class="ms-dropzone__hint">WAV, MP3, M4A, FLAC - up to 10MB file</p>
        </ng-container>
        <p *ngIf="fileName" class="ms-dropzone__label">{{ fileName }}</p>
      </div>
    </div>

    <!-- URL -->
    <div *ngIf="activeTab === 'url'" class="ms-modal__body ms-modal__body--url">
      <p class="ms-url__label">Paste a link to a track</p>
      <div class="ms-url__input-wrap">
        <img class="ms-url__icon" src="assets/imgs/magic-search/ms-globe-icon.svg" width="16" height="16" alt="">
        <input class="ms-url__input" type="text" placeholder="https://...Youtube, SoundCloud, Spotify"
          [(ngModel)]="urlValue" />
      </div>
    </div>

    <div class="ms-modal__footer">
      <button class="ms-btn" (click)="cancel()">Cancel</button>
      <button class="ms-btn ms-btn--primary" [disabled]="!canSubmit" (click)="submit()">Attach -></button>
    </div>
</div>


